import { Icon } from "components/icon/Icon";

import "./Alert.scss";

export function Alert({
  children,
  onDismiss,
  className = "",
  variant = "success",
  ...rest
}) {
  const v = variant ? `alert-${variant}` : "";

  return (
    <div
      className={`alert ${v} ${className} d-flex justify-content-between`}
      {...rest}
    >
      <div>{children}</div>
      {onDismiss && (
        <Icon
          name="times cursor-pointer"
          className="ml-4"
          onClick={() => onDismiss()}
        />
      )}
    </div>
  );
}
